import React from 'react';

import {
  Switch,
  Route,
  useRouteMatch,
} from 'react-router-dom';

import Checkout from './components/Checkout';
import Receipt from './components/Receipt';
import LinePayPayment from './components/LinePayPayment';

const CheckoutPage = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${path}/history`}>
        <Receipt />
      </Route>
      <Route exact path={`${path}/receipt`}>
        <Receipt />
      </Route>
      <Route path={`${path}/line-pay-payment`}>
        <LinePayPayment />
      </Route>
      <Route path={`${path}`}>
        <Checkout />
      </Route>
    </Switch>
  );
};

export default CheckoutPage;
